// @flow
import * as React from "react";
import tw from "tailwind-styled-components";

type Props = {
  $error?: boolean,
};

const FormInput: React.ComponentType<Props> = tw.input`
  form-input
  focus:!border-primary
  focus:shadow-[0_0_0_2px_rgba(5,130,255,0.08)]
  border
  rounded-md
  block
  w-full
  transition
  duration-150
  ease-in-out
  text-gray-700
  sm:text-sm
  sm:leading-5

  ${(props: Props) => {
    if (!props.$error) return "";

    return `
      border-red-500
    `;
  }}
`;

export default FormInput;
